export default function RcmpAlertIcon(props) {
  return (
    <svg
      width="61"
      height="54"
      viewBox="0 0 61 54"
      fill={ props.fill || "#3B454F" }
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M60.3182 46.1667L34.9253 2.83334C33.9491 1.16668 32.2348 0.333344 30.5205 0.333344C28.8063 0.333344 27.092 1.16668 26.0086 2.83334L0.627689 46.1667C-1.21636 49.4881 1.21709 53.6667 5.13245 53.6667H55.9182C59.8182 53.6667 62.2586 49.5 60.3182 46.1667ZM6.30388 47.9524L30.4134 6.61906L54.7348 47.9524H6.30388ZM30.5205 36.6548C28.4539 36.6548 26.7777 38.331 26.7777 40.3976C26.7777 42.4643 28.4575 44.1405 30.5253 44.1405C32.5932 44.1405 34.2634 42.4643 34.2634 40.3976C34.2586 38.3333 32.592 36.6548 30.5205 36.6548ZM27.6634 18.4286V29.8572C27.6634 31.4405 28.9491 32.7143 30.5205 32.7143C32.092 32.7143 33.3777 31.4345 33.3777 29.8572V18.4286C33.3777 16.8572 32.1039 15.5714 30.5205 15.5714C28.9372 15.5714 27.6634 16.8572 27.6634 18.4286Z" />
    </svg>
  )
}
